import type { UpdateableAreaDimensions } from '../../areas'
import { calculateDimensionValues } from './calculate-dimension-values'

export function calculateDimensions(args?: {
  dimensions: UpdateableAreaDimensions
  areaType?: 'surface' | 'room'
}): UpdateableAreaDimensions {
  const { dimensions, areaType } = args
  const { override, length, width, height } = dimensions

  // if the dimensions have been overridden, we don't want
  // to touch them at all
  if (override) {
    return { ...dimensions }
  }
  const {
    lnft: lnftValue,
    sqft: sqftValue,
    sqftWalls: sqftWallsValue,
    sqftFloor: sqftFloorValue,
    sqftCeiling: sqftCeilingValue,
    cuft: cuftValue
  } = calculateDimensionValues({
    length: Number(length),
    width: Number(width),
    height: Number(height),
    isRoom: !(areaType === 'surface')
  })

  const calculatedDimensions = {
    ...dimensions,
    lnft: {
      ...dimensions.lnft,
      default: lnftValue
    },
    sqft: {
      ...dimensions.sqft,
      default: sqftValue
    },
    cuft: {
      ...dimensions.cuft,
      default: cuftValue
    },
    sqftWalls: {
      ...dimensions.sqftWalls,
      default: sqftWallsValue
    },
    sqftCeiling: {
      ...dimensions.sqftCeiling,
      default: sqftCeilingValue
    },
    sqftFloor: {
      ...dimensions.sqftFloor,
      default: sqftFloorValue
    }
  }

  return calculatedDimensions
}
